import PrivacyPolicy from '@/assets/wellbet/pdf/privacy_policy.pdf';
import TermsAndConditions from '@/assets/wellbet/pdf/terms_and_conditions.pdf';

export default {
  PrivacyPolicy,
  TermsAndConditions,
};
